import { ToMetadata } from '@nucleus/bonds';
import { z } from 'zod';

// TODO: this should be inferred from the schema, but it's currently used as a generic throughout the codebase
export type ActionItem<T> = {
  id: string;
  title: string;
  type: T;
  destination?: string;
  openInNewTab?: boolean;
};

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type ActionItemApi<T, M = {}> = ActionItem<T> & {
  metadata?: ToMetadata & M;
};

export const ActionItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  type: z.string(),
  destination: z.string().optional(),
  openInNewTab: z.boolean().optional(),
});
